var Genesis =  require("./GenesisExport.js");

Genesis.namespace = function (ns_string) {
    var parts = ns_string.split('.'),
        parent = Genesis,
        i;

    if (parts[0] === "Genesis") {
        parts = parts.slice(1);
    }
    for (i = 0; i < parts.length; i += 1) {
        if (typeof parent[parts[i]] === "undefined") {
            parent[parts[i]] = {};
        }
        parent = parent[parts[i]];
    }

    return parent; 
};

Genesis.extendNamespace = function (ns_string, extension) {
    var parts = ns_string.split('.');
    var parent = Genesis;

    if (parts[0] === "Genesis") {
        parts = parts.slice(1);
    }

    var lastPartIndex = parts.length - 1;
    for (var i = 0; i < parts.length; i += 1) {
        if (typeof parent[parts[i]] === "undefined") {
            parent[parts[i]] = {};
        }

        if (i === lastPartIndex) {
            parent[parts[i]] =
                _.isFunction(extension)
                    ? _.extend(extension, parent[parts[i]])
                    : _.extend(parent[parts[i]], extension);
        }

        parent = parent[parts[i]];
    }

    return parent;
};

Genesis.url = function (pattern, params) {
    params = params || {};

    if (pattern[0] === '/') {
        pattern = pattern.substring(1);
    }

    var relative = pattern;

    for (var p in params) {
        if (!params.hasOwnProperty(p))
            continue;

        relative = relative.replace(':' + p, params[p]);
    }

    var approot = _iSitePathBase ? _iSitePathBase : "";
    return approot + relative;
};

Genesis.redirect = function (url, absoluteUrl) {
    if (!absoluteUrl) {
        url = Genesis.url(url);
    }

    window.location.href = url;
};

Genesis.setStorageItem = function (key, value) {
    localStorage.setItem(key, JSON.stringify(value));
};

Genesis.getStorageItem = function (key) {
    return JSON.parse(localStorage.getItem(key));
};

Genesis.setupTooltips = function () {
    /*
     * Fire tooltips
     */
    var tooltipElements = $("[rel=tooltip]");
    if (tooltipElements.length) {
        tooltipElements.tooltip();
    }
};

Genesis.registerComponent = function (componentName, template, createViewModel) {
    if (!ko.components.isRegistered(componentName)) {
        ko.components.register(componentName, {
            viewModel: {
                createViewModel: createViewModel
            },
            template: template
        });
    }
};

Genesis.isScrollbarVisible = function () {
    return window.innerWidth > document.documentElement.clientWidth;
};
module.exports = Genesis;